import React from 'react';
import BrandTypography from '@justpark/ui/src/components/BrandTypography';
import Typography from '@justpark/ui/src/components/Typography';
import ListLinks from '@justpark/ui/src/components/ListLinks';
import ImageOverlap from './ImageOverlay';
import imageResizer from '../../helpers/imageResizer';

import styles from '../../../static/scss/components/landing/whatsNearby.module.scss';

type Props = {
  description: string,
  locations: Array<any>,
  linkComponent: any
};

const largeImage = [
  {
    width: 382,
    height: 382,
    fit: 'cover'
  }
];

const smallImage = [
  {
    width: 174,
    height: 174,
    fit: 'cover'
  }
];

const WhatsNearby = ({ description, locations, linkComponent }: Props) => (
  <div className={styles.base}>
    <div className={styles.left}>
      <div className={styles.list}>
        <BrandTypography level={2} bold>
          {`What's Nearby`}
        </BrandTypography>
        <Typography className={styles.description} size="h2" bold>
          <div>{description}</div>
        </Typography>
        <ListLinks list={locations} linkComponent={linkComponent} />
      </div>
    </div>
    <div className={styles.right}>
      <div className={styles.images}>
        <ImageOverlap
          largeImageSrc={imageResizer(locations[0].url, largeImage).src}
          largeImageAlt={locations[0].title}
          smallImageSrc={imageResizer(locations[1].url, smallImage).src}
          smallImageAlt={locations[1].title}
        />
      </div>
    </div>
  </div>
);

export default WhatsNearby;
